import { connect } from 'react-redux'
import PlayInList, { PlayInListProps } from './PlayInList'
import { State } from '../../dataStore/reducers/reducerType'

const mapStateToProps = (state: State, props: Pick<PlayInListProps, 'dataBdd' | 'listHeight' | 'emptyRenderer' | 'showRemoveButton'>): PlayInListProps => ({
  dataBdd: props.dataBdd,
  emptyRenderer: props.emptyRenderer,
  list: state.playIn.playInDetails,
  listHeight: props.listHeight,
  scrollToIndex: state.playIn.playInDetails.length - 1,
  showRemoveButton: props.showRemoveButton,
  total: state.playIn.playInDetails.length
})

export default connect(mapStateToProps)(PlayInList)
